/* Live */
import cookie from "react-cookies";
export const apiUrl = process.env.REACT_APP_API_URL;
export const ecommerceapiUrl = process.env.REACT_APP_ECOMMERCE;
export const ecommerceMainUrl = process.env.REACT_APP_ECOMMERCE_MAIN;


export const baseUrl = process.env.REACT_APP_BASE_URL;
export const siteMainURL = process.env.REACT_APP_BASE_URL;
export const frontURL = process.env.REACT_APP_FRONTURL;
export const editorURL = 'https://emailbuilder.epicpay.ai/';

export const defaultUniqueID = "11427810-47D6-4977-AC44-CFA53992B77A";
export const deliveryId = "e405c6e5-1526-443d-8809-e149df521133";
export const pickupId = "962ac11f-aaf3-4ba0-8417-b7efb812b939";
export const CountryTxt = "Singapore";
export const productNoImg = "/img/product-noimg.jpg";
export const adminlimit = 10;
var accesstoken = {
  Authorization: `Bearer ${cookie.load("accessToken")}`,
};

export const masterheaderconfig = {
  headers: accesstoken,
};

var clientaccesstoken = {
  Authorization: `Bearer ${cookie.load("clientAccessToken")}`,
};

export const clientheaderconfig = {
  headers: clientaccesstoken,
};
